import React from 'react';
import UserHome from './index';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <Route
    key="/business/user/home"
    element={
      <DefaultBusinessLayout showDemoStore={false} showContactSales={false} />
    }
  >
    <Route path="business/user/home" element={<UserHome />} />
  </Route>,
];
